import './css-variables';
import './fancybox';
import './aos';
import './location';
import './customers';
import './services';

$(document).ready(function () {
  $('.navigation__trigger').click(function(){
    $('body').toggleClass('menu-active');
  });
});
